import React, { useContext } from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";
import { EditBuzzIdsButton as EditDeliveryEndpointButton } from "./edit/EditBuzzIdsButton";

export const BuzzIdsSection: React.VFC = () => {
    const { systemPlatformDetailsItem, isLoading } = useContext(SystemPlatformDetailsContext);

    const { buzzIds } = systemPlatformDetailsItem;

    const editDeliveryInfoButton: ButtonRenderProps = {
        render: EditDeliveryEndpointButton
    };

    return (
        <ContentSection header="Buzz Ids" buttons={[editDeliveryInfoButton]} isLoading={isLoading}>
            {buzzIds?.join(", ")}
        </ContentSection>
    );
};
